<div class="wrapper" [routerLink]="'/notifications'">
    <div class="lb-badge">
<!--        *ngIf="totalNotifications > 0"-->
        <span  class="counter">
            {{totalNotifications}}
        </span>
    </div>
<!--    <i class="fa fa-bell" aria-hidden="true"> </i>-->
</div>
